import Grid from '@mui/material/Grid';
const App=()=>{
  return  <Grid container>
            <Grid item xs>
              222
            </Grid>
          </Grid>
}
export default App
